import { render, staticRenderFns } from "./FashionShow.vue?vue&type=template&id=210546d6&scoped=true"
import script from "./FashionShow.vue?vue&type=script&lang=js"
export * from "./FashionShow.vue?vue&type=script&lang=js"
import style0 from "./FashionShow.vue?vue&type=style&index=0&id=210546d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210546d6",
  null
  
)

export default component.exports